import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import { RoleProtectedRoute } from './components/common';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CheckRegistrationPage from './pages/CheckRegistrationPage';
import CheckListPage from './pages/CheckListPage';
import CheckPaidPage from './pages/CheckPaidPage';
import CheckIssuesPage from './pages/CheckIssuesPage';
import CheckDateChangesPage from './pages/CheckDateChangesPage';
import CheckDetailPage from './pages/CheckDetailPage';
import DepositNewPage from './pages/DepositNewPage';
import DepositListPage from './pages/DepositListPage';
import DepositDetailPage from './pages/DepositDetailPage';
import ReportDailyPage from './pages/ReportDailyPage';
import ReportWeeklyPage from './pages/ReportWeeklyPage';
import ReportPendingPage from './pages/ReportPendingPage';
import ReportCalendarPage from './pages/ReportCalendarPage';
import ReportClientesPage from './pages/ReportClientesPage';
import AuditLogPage from './pages/AuditLogPage';
import BanksPage from './pages/BanksPage';
import ClientsPage from './pages/ClientsPage';
import BankAccountsPage from './pages/BankAccountsPage';
import UsersPage from './pages/UsersPage';
import EmpresasPage from './pages/EmpresasPage';
import TiposNovedadPage from './pages/TiposNovedadPage';
import UserProfilePage from './pages/UserProfilePage';

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />} />

      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/perfil" element={<UserProfilePage />} />

          {/* Cheques - Registrar para cajero, contador y administrador */}
          <Route
            path="/cheques/nuevo"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'cajero', 'contador']}>
                <CheckRegistrationPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/cheques/editar/:id"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <CheckRegistrationPage isEdit />
              </RoleProtectedRoute>
            }
          />
          <Route path="/cheques/lista" element={<CheckListPage />} />
          <Route path="/cheques/pagados" element={<CheckPaidPage />} />
          <Route
            path="/cheques/novedades"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'cajero', 'contador']}>
                <CheckIssuesPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/cheques/cambio-fecha"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <CheckDateChangesPage />
              </RoleProtectedRoute>
            }
          />
          <Route path="/cheques/:id" element={<CheckDetailPage />} />

          {/* Depósitos - Solo para administrador, contador y auditor (NO cajero) */}
          <Route
            path="/depositos/nuevo"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <DepositNewPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/depositos/lista"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <DepositListPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/depositos/:id"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <DepositDetailPage />
              </RoleProtectedRoute>
            }
          />

          {/* Reportes - Solo para administrador, contador y auditor */}
          <Route
            path="/reportes/diario"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <ReportDailyPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/reportes/semanal"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <ReportWeeklyPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/reportes/pendientes"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <ReportPendingPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/reportes/calendario"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador', 'auditor']}>
                <ReportCalendarPage />
              </RoleProtectedRoute>
            }
          />
          <Route path="/reportes/clientes" element={<ReportClientesPage />} />

          {/* Auditoría - Solo para administrador y auditor */}
          <Route
            path="/auditoria"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'auditor']}>
                <AuditLogPage />
              </RoleProtectedRoute>
            }
          />

          {/* Catálogos - Solo para administrador y contador */}
          <Route
            path="/catalogos/bancos"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <BanksPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/catalogos/clientes"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <ClientsPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/catalogos/cuentas"
            element={
              <RoleProtectedRoute allowedRoles={['administrador']}>
                <BankAccountsPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/catalogos/novedades"
            element={
              <RoleProtectedRoute allowedRoles={['administrador', 'contador']}>
                <TiposNovedadPage />
              </RoleProtectedRoute>
            }
          />

          {/* Usuarios y Empresas - Solo para administrador */}
          <Route
            path="/catalogos/usuarios"
            element={
              <RoleProtectedRoute allowedRoles={['administrador']}>
                <UsersPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/administracion/empresas"
            element={
              <RoleProtectedRoute allowedRoles={['administrador']}>
                <EmpresasPage />
              </RoleProtectedRoute>
            }
          />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function PrivateRoute() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <MainLayout />;
}

export default App;
